/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React, { useEffect } from "react";
import { useNotificationGroupData } from "./hooks";
import { setBasicDialogOpenFor, setErrorMsg as clearStoreErrorMsg } from "../../../store/helpers/helperReducers";
import { Sheet } from "../../ui/sheet";
import { Button } from "../../ui/button";
import { InputField } from "../../Shared/Radix/Inputs/InputField";

const AddNotificationGroup: React.FC = () => {
  const { dispatch, submitHandler, groupStatus, groupData, setGroupData, errorMsg, setErrorMsg } = useNotificationGroupData();

  useEffect(() => {
    setErrorMsg({});
    dispatch(clearStoreErrorMsg({ groupName: "" }));
  }, []);

  const handleChange = (name: string, value: string) => {
    setGroupData({ ...groupData, [name]: value });
    setErrorMsg({ ...errorMsg, [name]: "" });
  };

  const handleClose = () => {
    setErrorMsg({});
    dispatch(setBasicDialogOpenFor(undefined));
  };

  const isDisabledSave = !groupData?.groupName || groupStatus.isLoading;

  const footer = (
    <>
      <Button variant="outline" onClick={handleClose} disabled={groupStatus.isLoading}>
        Cancel
      </Button>
      <Button onClick={submitHandler} disabled={isDisabledSave}>
        Save
      </Button>
    </>
  );

  return (
    <Sheet open={true} onClose={handleClose} title="Add Notification Group" footer={footer} width="520px">
      <form autoComplete="off">
        <div className="space-y-5 pt-2">
          <div>
            <InputField
              label="Group Name"
              name="groupName"
              disabled={groupStatus.isLoading}
              value={groupData?.groupName}
              onChange={handleChange}
              maxLength={255}
              placeholder="Enter group name"
              required
              tooltipText="Maximum length: 255 characters"
              autoFocus={true}
            />
          </div>
        </div>
      </form>
    </Sheet>
  );
};

export default AddNotificationGroup;
